import { InvoiceFourData } from "../../../../../data/applications/ECommerce";

// This component displays the invoice table body with the product details, quantities, prices, and total amounts.
const InvoiceTableBody = () => {
  return (
    <tbody className="table-invoice">
      {/* Mapping through InvoiceFourData which will render invoice items dynamically */}
      {InvoiceFourData.map((data, i) => (
        <tr key={i}>
          <td >
            <h4 >{data.title}</h4>
            <span >{data.detail}</span>
          </td>
          <td>
            <span>
              {`$`}
              {data.price}.00
            </span> 
          </td>
          <td>
            <span>{data.quantity}</span> 
          </td>
          <td>
            <span>
              {`$`}
              {data.total}.00
            </span>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default InvoiceTableBody;